import { ISocialPlatform } from '@/interfaces/socials'
import { MetaData } from '../hooks/meta'
import { validSocialNetworks } from '../validations/social'
import { ProjectImageFormat } from '@/interfaces/project'

export const getSocialNetworkByUrl = (url: string) => {
  try {
    const urlObject = new URL(url)
    const socialNetwork = validSocialNetworks?.find((social) => {
      return urlObject.host.includes(social.name)
    })
    return socialNetwork?.name
  } catch (e) {
    return null
  }
}

export const getImageFormatFromMeta = (meta: MetaData): ProjectImageFormat => {
  const social = getSocialNetworkByUrl(meta.url)
  if (social) {
    switch (social) {
      case ISocialPlatform.TIKTOK:
        return {
          width: meta?.thumbnail_width || 720,
          height: meta?.thumbnail_height || 1280,
        }
      case ISocialPlatform.YOUTUBE:
        return {
          width: Number(meta?.width) || 1280,
          height: Number(meta?.height) || 720,
        }
      case ISocialPlatform.INSTAGRAM:
        return {
          width: Number(meta?.jsonld?.image[0]?.width) || 1080,
          height: Number(meta?.jsonld?.image[0]?.height) || 1080,
        }
      default:
        return {
          width: 1080,
          height: 1080,
        }
    }
  }
}

export const getPaddingBottomAspectRation = (
  imageFormat?: ProjectImageFormat
) => {
  if (!imageFormat) return '100%'
  const { width, height } = imageFormat
  return `${(height / width) * 100}%`
}

// https://www.instagram.com/p/CbC8rMGt4Ga/?igshid=YmMyMTA2M2Y=
// https://www.instagram.com/p/CQXTaWAJLns/?igshid=YmMyMTA2M2Y= (video)
// https://www.instagram.com/p/CaXmh8ntKkc/?igshid=YmMyMTA2M2Y= ( carousel)
